import { Box, Grid, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
export default function LeftSection() {
  // StepItem component for rendering each step with an icon
  const StepItem = ({ step, description }) => {
    return (
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: 2 }}>
        <CheckCircleOutlineIcon sx={{ color: "#fafafa", marginRight: 1 }} />
        <Typography variant="body1">
          Step {step}: {description}
        </Typography>
      </Box>
    );
  };
  return (
    <Grid
      item
      xs={12}
      md={3}
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          background: (theme) => theme.palette.primary.main,
          height: "100%",
          paddingY: { xs: 2, md: 4 },
          paddingX: 2,
          borderRadius: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "#fafafa",
          justifyContent: { xs: "center", md: "start" },
        }}
      >
        <img src="/logo_plain.png" width={"80%"} alt="logo" />
        <Typography variant="h4" textAlign={"center"} mt={{ xs: 2, md: 6 }}>
          Schedule an Appointment
        </Typography>
        {/* Sub note */}
        <Typography
          variant="body2"
          mt={1}
          sx={{
            fontWeight: "bold",
            backgroundColor: "rgba(255,255,255,0.2)",
            padding: "2px 8px",
            borderRadius: "8px",
          }}
        >
          For online appointments only
        </Typography>

        {/* Step description section */}
        <Stack mt={4} display={{ xs: "none", md: "flex" }}>
          <Typography variant="h6" mb={2} fontWeight={400}>
            Please complete the following steps
          </Typography>
          <StepItem step={1} description="Choose a Doctor" />
          <StepItem step={2} description="Pick a Time" />
          <StepItem step={3} description="Appointment Info" />
          <StepItem step={4} description="Payment Details" />
        </Stack>
        <Typography
          // variant="body2"
          // mt={2}
          // sx={{
          //   backgroundColor: "rgba(255,255,255,0.2)",
          //   paddingY: 1.5,
          //   paddingX: 1.5,
          //   borderRadius: "8px",
          //   border: "1px solid #fafafa",
          // }}
          variant="body2"
          mt={2}
          sx={{
            // width: "100%",
            backgroundColor: "rgba(255,255,255,0.12)",
            backdropFilter: "blur(6px)",
            padding: 2,
            borderRadius: "12px",
            border: "1px solid rgba(255,255,255,0.3)",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            lineHeight: 1.6,
          }}
        >
          If you have any questions, please contact us at{" "}
          <a
            href="mailto:contact@ekko.pk"
            style={{
              color: "#fff",
              textDecoration: "underline",
              fontWeight: "600",
            }}
          >
            contact@ekko.pk
          </a>{" "}
          or send a message on WhatsApp{" "}
          <a
            href="https://wa.me/923439309980"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#fff",
              textDecoration: "underline",
              fontWeight: "600",
            }}
          >
            +92 343 9309980
          </a>
          .
        </Typography>
      </Paper>
    </Grid>
  );
}
